import React, { FC, useRef, useState } from 'react'
import classes from '../styles.module.scss';
import { createCn } from '../../../helpers/utils';
import { useTranslation } from 'react-i18next';
import { ChevronDown, GreenTick } from '../../../assets';
import { useOutsideClick } from '../../../hooks/useOutsideClick.hook';
import { NO_PROJECT } from '../../../contexts/tasks.context';

interface IProps {
  /** Названия проектов (значения поля project задач) + NO_PROJECT для задач без проекта. */
  projects: string[];
  selectedProject: string | null;
  setSelectedProject: (project: string) => void;
}

const cn = createCn("tasks", classes);

const ProjectSelect: FC<IProps> = ({
  projects,
  selectedProject,
  setSelectedProject,
}) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");

  const projectLabel = (project: string): string =>
    project === NO_PROJECT ? t('tasks-board.no-project') : project;

  const filteredProjects = projects.filter(p =>
    projectLabel(p).toLowerCase().includes(query.toLowerCase()),
  );
  const dropDownRef = useRef<HTMLDivElement>(null);

  useOutsideClick(dropDownRef, () => setOpen(false));

  return (
    <div className={cn("project-select")}>
      <div className={cn("project-select__label")} >
        {t('tasks.projects')}
      </div>

      <div className={cn("project-select__wrapper")} ref={dropDownRef}>
        <div className={cn("project-select__input")} onClick={() => setOpen(!open)}>
          {selectedProject ? projectLabel(selectedProject) : t('tasks.select-project')}
          <ChevronDown style={{
            transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
          }} />
        </div>

        {open && (
          <div className={cn("project-select__dropdown")} >
            <input
              type="text"
              className={cn("project-select__input")}
              placeholder={t('tasks.project')}
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              style={{ maxWidth: '20rem' }}
            />
            <div className={cn("project-select__options")}>
              {filteredProjects.length > 0 ? (
                filteredProjects.map((project) => (
                  <div
                    key={project}
                    className={cn("project-select__option", {
                      'project-select__option--selected': selectedProject === project
                    })}
                    onClick={() => {
                      setSelectedProject(project);
                      setQuery("");
                      setOpen(false);
                    }}
                  >
                    {projectLabel(project)}
                    {selectedProject === project && <GreenTick />}
                  </div>
                ))
              ) : (
                <div className={cn("project-select__no-options")}>
                  {t('tasks.no-projects')}
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default ProjectSelect
